import Axios from '../../axiosConfig';
import { BACKEND_URL } from '../../config';
import { configure, runInAction, makeAutoObservable } from 'mobx';
import { DirectoryDto, SaveDirectoriesRequest } from '../../types/directory';
import RootModule from '../rootModule';

configure({ enforceActions: 'observed' });

/**Provides directory related variables and methods */
export default class DirectoryModule {
    private rootModule: RootModule;
    private directories: DirectoryDto[] = [];

    constructor(rootModule: RootModule) {
        makeAutoObservable(this, {}, { autoBind: true });
        this.rootModule = rootModule;
    }

    public async fetchDirectories(): Promise<void> {
        const response = await Axios({
            method: 'GET',
            url: BACKEND_URL + `directory/getDirectories/${this.rootModule.organization.currentOrganizationId}`,
            withCredentials: true,
        });
        runInAction(() => {
            this.directories = [
                ...response.data.shvkDirectories,
                ...response.data.evaDirectories,
                ...response.data.anotherDirectories,
            ];
        });
    }

    public async saveDirectories(directoryData: SaveDirectoriesRequest): Promise<void> {
        await Axios({
            method: 'POST',
            url: BACKEND_URL + 'directory/saveDirectories',
            data: directoryData,
        });
    }
    public get evaDirectories(): DirectoryDto[] {
        return this.directories.filter((d) => d.type === 'EVA');
    }

    public get shvkDirectories(): DirectoryDto[] {
        return this.directories.filter((d) => d.type === 'SHVK');
    }

    public get anotherDirectories(): DirectoryDto[] {
        return this.directories.filter((d) => d.type === 'ANOTHER');
    }
}
